import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { Divider } from './Divider';
export function BonusesSection() {
  const bonuses = [{
    title: "Obsequio 1 — Libreta de Gratitud y Provisión",
    value: '$17 USD',
    description: "llevaras a la práctica lo aprendido durante los 30 dias del Método R.E.V.E.L.A. Aquí podrás escribir tus refiexiones, oraciones, aprendizajes, bendiciones y evidencias de la fidelidad de Dios. Está libreta sera un testimonio personal de tu proceso, de tus avances y de las maneras en que has visto la provision de Dios"
  }, {
    title: "Obsequio 2 — 4 Meditaciones Guiadas R.E.V.E.L.A.",
    value: '$25 USD',
    description: 'Una meditación especial al finalizar cada semana de los 30 días. Diseñadas para profundizar lo que aprendiste y consolidarlo en tu mente y espíritu antes de continuar.'
  }, {
    title: "Obsequio 3 — 100 Promesas Bíblicas para Vivir en Abundancia desde la Fe",
    value: '$15 USD',
    description: 'Organizadas por categorías para que en cualquier situación — duda, temor, escasez, incertidumbre — tengas la Palabra exacta de Dios lista para declarar sobre tu vida.'
  }];
  return <section className="w-full bg-[#0B1A3A] py-20 px-6" style={{
    backgroundColor: "#5B401F",
    backgroundImage: "none"
  }} data-id="element-34" data-mp="2lvuyoh3ahpo">
      <div className="max-w-5xl mx-auto" data-id="element-35" data-mp="7lqkoop4p195">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-center text-white mb-4" data-id="element-36" data-mp="7imddigd9pe9">
          Además recibirás 3 obsequios exclusivos
        </motion.h2>

        <Divider data-id="element-37" data-mp="qa5che79sjb0" />

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-38" data-mp="qaos2o9g6vlv">
          <img src="https://cdn.magicpatterns.com/uploads/a6oiFjEMPQpiAGHMNHwVqT/EL_JARDIN_SUBCONSCIENTE_(4).png" alt="Método R.E.V.E.L.A. - Bonos incluidos" className="w-full max-w-4xl mx-auto rounded-lg shadow-2xl" data-id="element-39" data-mp="akz6s2lmv4lt" />
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-40" data-mp="kbtu7aam8a8u">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-gradient-to-br from-[#0A1535] to-[#0B1A3A] border border-[#E0B756]/20 rounded-lg p-6 hover:border-[#E0B756]/40 transition-colors" style={{
          backgroundImage: "linear-gradient(180deg, #F7F2E7 0%, #F7F2E7 100%)"
        }} data-id="element-41" data-mp="fjai6hrktn65" data-mpi={index}>
              <div className="flex items-start gap-4 mb-3" data-id="element-42" data-mp="351swp48w5r42">
                <Gift className="w-8 h-8 text-[#E0B756] flex-shrink-0" data-id="element-43" data-mp="302y6vicib2ag" />
                <div data-id="element-44" data-mp="1fk5ii3mdfnop">
                  <h3 className="text-xl font-bold text-[#E0B756]" data-id="element-45" data-mp="1fjm42wvxjhff">
                    {bonus.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-2" data-id="element-46" data-mp="1khxcd36ktjvj">
                    <span className="text-gray-400 line-through text-sm" style={{
                  color: "#0A1535"
                }} data-id="element-47" data-mp="15uucwqyp115k">
                      Valor: {bonus.value}
                    </span>
                    <span className="inline-block bg-[#E0B756] text-[#0A1535] text-xs font-bold uppercase tracking-wide px-2.5 py-1 rounded-full" data-id="element-48" data-mp="wteelhl5kphp">
                      Hoy Gratis
                    </span>
                  </div>
                </div>
              </div>
              <p className="text-gray-300 leading-relaxed pl-12" style={{
            color: "#0A1535"
          }} data-id="element-49" data-mp="rujl9lpk7ijc">
                {bonus.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}